import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    setWeekCount,
    onDragEnd,
    getJobpacks,
    getTrackOrder,
    setTrackOrder,
    getTrackSubjects
} from "./actions";
import { push } from "connected-react-router";
import {
    selectWeekCount,
    selectTrackOrder,
    selectTrackSubjectsForAddMenu,
    selectTracksForView,
    selectYearString
} from "./selectors";
import { hot } from "react-hot-loader/root";
import { Card, CardHeader, CardContent,Button,Typography } from "@material-ui/core";
import styled from "styled-components";
import { RouteComponentProps } from "react-router";
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import { Track } from "./Track";
import { DateSelector } from "./DateSelector";
import { ControlCell } from "./ControlCell";
import { AddSubjectModal } from "./AddSubjectModal";
import Fullscreen from "react-fullscreen-crossbrowser";
import moment from "moment";
let date = new Date();
let year1 = moment(date).format("YYYY")
let month = moment(date).format("MMM").toLowerCase()

const sidebarWidth: number = 220;

interface IMainContainer {
    weekCount: number;
    trackCount: number;
    isfull: string;
}

const MainContainer = styled.div<IMainContainer>`
    background: #3f52b5;
    width: 100%;
    height: ${props =>
        props.isfull === "true" ? "100%" : "calc(100vh - 220px)"};
    border-radius: 4px;
    display: grid;
    grid-template-rows: 20px 30px 1fr;
    grid-template-columns: ${sidebarWidth}px repeat(
            ${props => props.weekCount * 7},
            1fr
        );
    grid-gap: 2px;
    overflow: scroll;
`;

interface IAllTracksContainer {
    weekCount: number;
}
const AllTracksContainer = styled.div<IAllTracksContainer>`
    grid-row-start: 3;
    grid-row-end: 3;
    grid-column-start: 1;
    grid-column-end: ${props => props.weekCount * 7 + 2};
`;

const YearContainer = styled.div<IAllTracksContainer>`
    grid-row: 1;
    grid-column-start: 1;
    grid-column-end: ${props => props.weekCount * 7 + 2};
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: auto 60px auto;
`;

const Year = styled.div`
    grid-row: 1;
    grid-column-start: 2;
    grid-column-end: 3;
    color: white;
`;
interface IStyledCardContent {
    isfull: string;
}
const StyledCardContent = styled(CardContent)<IStyledCardContent>`
    && {
        height: ${props => (props.isfull === "true" ? "100vh" : "")};
        padding: ${props => (props.isfull === "true" ? "10px" : "")};
        padding-bottom: ${props => (props.isfull === "true" ? "20px" : "")};
        background: white;
    }
`;
interface IResourcePlannerProps extends RouteComponentProps {
    trackSubjectFirebasePath: string;
    trackNameLodashPath: Array<string>;
    resourceSubjectFirebasePath: string;
    resourceNameLodashPath: Array<string>;
    name: string;
}


const ResourcePlanner = (props: IResourcePlannerProps) => {
    const dispatch = useDispatch();
    const weekCount = useSelector(selectWeekCount);
    const trackOrder = useSelector(selectTrackOrder);
    const tracks = useSelector(selectTracksForView);
    const year = useSelector(selectYearString);
    const [addTrackModalOpen, setAddTrackModalOpen] = useState(false);
    useEffect(() => {
        dispatch(setWeekCount(1));
        dispatch(getTrackOrder());
        dispatch(getTrackSubjects());
        dispatch(getJobpacks(year1,month));
    }, [dispatch]);

    const [isFull, setIsFull] = useState(false);
    return (
        <>
            <Card>
                <CardHeader title={<>{props.name } 
                        <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            style={{float:"right"}}
                            onClick={()=>{
                                dispatch(push(`/job-pack-create/jobpacks/active/year/month/uid`));
                            }}
                        >
                            <Typography style={{ color: "white" }}>
                                New Jobpack
                            </Typography>
                        </Button>
                   </> } />
                
                <Fullscreen
                    enabled={isFull}
                    onChange={isFull => setIsFull(isFull)}
                >
                    <div className="full-screenable-node">
                        <StyledCardContent isfull={isFull.toString()}>
                            <DragDropContext
                                onDragEnd={(result, provided) =>
                                    dispatch(onDragEnd(result, provided))
                                }
                            >
                                {trackOrder && (
                                    <MainContainer
                                        trackCount={trackOrder.length}
                                        weekCount={weekCount}
                                        isfull={isFull.toString()}
                                    >
                                        <YearContainer weekCount={weekCount}>
                                            <Year>{year}</Year>
                                        </YearContainer>
                                        <ControlCell
                                            setAddTrackModalOpen={
                                                setAddTrackModalOpen
                                            }
                                            isFull={isFull}
                                            setIsFull={isFullReally =>
                                                setIsFull(isFullReally)
                                            }
                                        />
                                        <DateSelector weekCount={weekCount} />

                                        <Droppable
                                            droppableId={`all-tracks`}
                                            direction="vertical"
                                            type="tracks"
                                        >
                                            {provided => (
                                                <AllTracksContainer
                                                    {...provided.droppableProps}
                                                    ref={provided.innerRef}
                                                    weekCount={weekCount}
                                                >
                                                    {tracks &&
                                                        tracks.map((e, i) => (
                                                            <Track
                                                                id={
                                                                    e.vehicle
                                                                        .machine_reg
                                                                }
                                                                index={i}
                                                                trackCount={
                                                                    tracks.length
                                                                }
                                                                weekCount={
                                                                    weekCount
                                                                }
                                                                sidebarWidth={
                                                                    sidebarWidth
                                                                }
                                                                key={
                                                                    e.vehicle
                                                                        .machine_reg
                                                                }
                                                                name={
                                                                    e.vehicle
                                                                        .machine_desc
                                                                }
                                                                reg={
                                                                    e.vehicle
                                                                        .machine_reg
                                                                }
                                                                days={e.days}
                                                            />
                                                        ))}

                                                    {provided.placeholder}
                                                </AllTracksContainer>
                                            )}
                                        </Droppable>
                                    </MainContainer>
                                )}
                            </DragDropContext>
                        </StyledCardContent>
                    </div>
                </Fullscreen>
            </Card>
            <AddSubjectModal
                open={addTrackModalOpen}
                onClose={() => setAddTrackModalOpen(false)}
                nameLodashPath={props.trackNameLodashPath}
                selectSubjectsForAddMenu={selectTrackSubjectsForAddMenu}
                setChosenSubjects={setTrackOrder}
                name="Track"
            />
        </>
    );
};

export default hot(ResourcePlanner);
